import {plausibleEvent, trapFocus} from '../utils';
import scrollLock from 'scroll-lock';
import gsap from 'gsap';
import {Flip} from 'gsap/Flip';
import {IndicatorModal} from "./IndicatorModal";

gsap.registerPlugin(Flip);

export default class Modal {
	constructor(el) {
		this.el = el; // The element that triggers the modal
		this.modal = document.querySelector('[data-impact-modal]');
		this.closeButton = this.modal.querySelector('[data-modal-close]');
		this.closeIndicatorButton = this.modal.querySelector('[data-indicator-modal-close]');
		this.modalContainer = this.modal.querySelector('[data-modal-wrapper]');
		this.modalContent = this.modal.querySelector('[data-content]');
		this.modalInner = this.modal.querySelector('[data-modal-inner]');
		this.modalOuter = this.modal.querySelector('[data-modal-outer]');

		this.indicators = [];

		this.isOpen = false;


		this.el.addEventListener('click', (e) => {
			if (!e.target) {
				return;
			}

			const button = e.target?.closest('[data-open-modal]');

			if (!button) {
				return;
			}


			const id = button.dataset.openModal;

			if (!id) {
				return;
			}

			this.openModal(id);
		});

		this.modalContainer.addEventListener('click', (e) => {
			const isOutside = !event.target.closest('.c-modal__inner');
			if (isOutside) {
			  	this.closeModal();
			}
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.closeModal();
			}
		});

		// close modal
		this.closeButton.addEventListener('click', (e) => {
			this.closeModal();
		});
	}


	openModal(id) {
		plausibleEvent('Modal Open', {modalId: id});
		const template = this.el.querySelector(`[id="${id}"]`);

		if (!template) {
			return;
		}

		this.isOpen = id;

		scrollLock.disablePageScroll();

		this.setFocusToModal();

		this.modalContent.innerHTML = '';
		this.modalContent.appendChild(template.content.cloneNode(true));

		this.modal.querySelectorAll('[data-target]').forEach((indicator) => {
			this.indicators.push(new IndicatorModal(indicator, modal));
		});

		gsap.set(this.modal, {
			autoAlpha: 1,
		});

		const tl = gsap.timeline();

		tl.to(this.modalOuter, {
			opacity: 1,
			duration: 0.5,
		});

		tl.fromTo(
			this.modalContainer,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				duration: 0.3,
			},
			'-=0.3'
		);

		tl.fromTo(
			this.modalContainer,
			{
				translateY: 50,
			},
			{
				translateY: 0,
				duration: 0.4,
				ease: 'power2.out',
			},
			'<'
		);
	}

	closeModal() {
		if (!this.isOpen) {
			return;
		}

		plausibleEvent('Modal Close', {modalId: this.isOpen});
		this.isOpen = null;

		this.resetFocus();

		const tl = gsap.timeline({
			onComplete: () => {
				gsap.set([this.modal, this.closeIndicatorButton], {
					autoAlpha: 0,
				});

				scrollLock.enablePageScroll();

				this.modalContent.innerHTML = '';
			},
		});

		tl.to(
			this.modalContainer,
			{
				opacity: 0,
				duration: 0.3,
			},
			'<'
		);

		tl.to(
			this.modalOuter,
			{
				opacity: 0,
				duration: 0.3,
			},
			'-=0.2'
		);

		this.indicators.forEach((indicator) => {
			indicator.destroy();
		});

		this.indicators = [];
	}

	setFocusToModal() {
		this.modal.setAttribute('tabindex', '0');

		setTimeout(() => {
			this.modal.focus();
			this.removeTrapFocus = trapFocus(this.modal);
		});
	}

	resetFocus() {
		if (this.removeTrapFocus) {
			this.removeTrapFocus();
		}

		this.modal.removeAttribute('tabindex');

		setTimeout(() => {
			if (this.previousActiveElement) {
				this.previousActiveElement.focus();
				this.previousActiveElement = null;
			}
		});
	}

	destroy() {
	}
}



